import { Subscription } from 'rxjs';
import { LanguageService } from './../../Services/languageService';
import { Component, ViewContainerRef, HostListener } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { AddNewPolicyMdl } from '../../Models/AddNewPolicy';
import { InsuredMdl } from '../../Models/InsuredMdl';
import { TranslateService } from '@ngx-translate/core';
import { LocationStrategy } from '@angular/common';
import { userinfo } from '../../Services/userinfo';
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { restURL } from '../../Models/restURL';
import { userService } from '../../Services/userService';
import Swal from 'sweetalert2';

@Component({
  selector: 'NewDashboard',
  templateUrl: './NewDashboard.html',
  styleUrls: ['./NewDashboard.css']
})
export class NewDashboard {

  public AddNewPolicyObj: AddNewPolicyMdl = new AddNewPolicyMdl();
  public RegObj: InsuredMdl = new InsuredMdl();
  public License: boolean;
  public OTP: boolean;
  public Vehicle: boolean;
  public Count: number = 1;
  public Motor: boolean;
  public SelectedType: string;
  public PolicyTrue: boolean;
  public DobRequired: boolean;
  public HasOtp: boolean;
  public BtnText: string;
  public HasSide: boolean;
  public isEnglish: boolean;
  public Lng: string;
  public lng: string;
  public InsuredName: string;
  public InsuredNameAr: string;
  public UserinfoSubscription: Subscription;
  public LngSubscription: Subscription;
  public ToggleClaims: boolean = false;
  public showLoading: boolean = false;

  constructor(private userInfo: userService, private http: HttpClient, private url: restURL, private router: Router, private lngService: LanguageService, private location: LocationStrategy, private translate: TranslateService, private usrinfo: userinfo) {

    this.AddNewPolicyObj.PolicyType = "5515";
    this.BtnText = "Proceed";
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
    if (sessionStorage.getItem("InsuredName") != null) {
      this.InsuredName = sessionStorage.getItem("InsuredName");
    }

    if (sessionStorage.getItem("NameAr") != null) {
      this.InsuredNameAr = sessionStorage.getItem("NameAr");
    }

    if (sessionStorage.getItem("Language") != null) {
      $("body").removeClass("Arabic");
      // this.translate.setDefaultLang(sessionStorage.getItem("Language"));
      if (sessionStorage.getItem("Language") == 'en') {
        this.translate.currentLang = "en";
        $("body").removeClass("Arabic");
        this.lngService.setLng("en")
        this.isEnglish = true;
      }
      else {
        this.translate.currentLang = "ar";
        this.lngService.setLng("ar")
        $("body").addClass("Arabic");
        this.isEnglish = false;
        this.Lng="ar"
        this.changeLanguage("ar");
      }
    }
    else {
      this.Lng="en"
      this.translate.setDefaultLang('en');
      this.translate.currentLang = "en";
      sessionStorage.setItem("Language", "en")
      this.lngService.setLng("en")
      $("body").removeClass("Arabic");
      this.isEnglish = true;
      this.changeLanguage("en");
    }
  }

  ToggleClass() {

    this.HasSide = !this.HasSide
  }
  GetOtp() {
    this.HasOtp = true;
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    // this.subscription.unsubscribe();
    // this.bindSubscription.unsubscribe();
    //this.UserinfoSubscription.unsubscribe();
  }
  changeLanguage(langauge) {

    if (langauge == "en") {
      this.isEnglish = true;
      sessionStorage.setItem("Language", "en");
      $("body").removeClass("Arabic");
    }
    else {
      this.isEnglish = false;
      $("body").addClass("Arabic");
      sessionStorage.setItem("Language", "ar");
    }
    //sessionStorage.setItem("Language",langauge)

    this.translate.use(langauge);
    this.lngService.setLng(langauge)
  }


  ngAfterViewInit() {
    $(document).ready(function () {
      $(document).on("click", ".Items .list-group a", function () {
        $(".Items .list-group a").removeClass("active")
        $(this).addClass("active");
      });

    })
  }
  ValidateIqama(evt: any) {
    if (this.RegObj.IqamaNo.length > 0) {
      if (evt.target.value.charAt(0) == "1") {
        this.DobRequired = true;
      }
      else {
        this.DobRequired = false;
      }
    }
    else {
      Swal("Please enter Iqama No")
    }

  }

  Next() {
    this.Count++;
    if (this.Count == 2) {
      this.OTP = true;
      this.License = false;
      this.BtnText = "Verify"
    }
    else if (this.Count == 3) {
      this.OTP = false;
      // this.PolicyTrue=true;
      this.router.navigate(['./PolicyDashboard/Policy']);
    }


  }

  checked(Event: any) {
    if (Event.target.checked) {
      this.AddNewPolicyObj.Transfer = true;
    }
    else {
      this.AddNewPolicyObj.Transfer = false;
    }
  }
  Back() {
    this.Motor = false;
  }

  Proceed() {

  }
  Motors() {
    this.Motor = true;
    this.SelectedType = "Motor TPL";
  }
  Comprehensive() {
    this.Motor = true;
    this.SelectedType = "Motor Comprehensive";
  }
  Medical() {
    this.Motor = true;
    this.SelectedType = "Medical Insurance";
  }


  gotoLogout() {

    //this.http.get<TravelstatusMdl>(this.url.baseURL+"travelBind/ValidateTravelCount?InsuredNo="+this.travelBindObj.propoalObj.Insured_IDNo,this.userinfo.getHttpOptions()).toPromise().then((result)=>{
    this.http.get<string>(this.url.baseURL + "/Registration/Logout?Token=" + sessionStorage.getItem("token").toString(), this.userInfo.getHttpOptions()).toPromise()
      .then((res) => {

      }, (error) => {
        Swal("Please try again later");
      });
    if (localStorage.getItem("Channel") == "Kiosk") {
      sessionStorage.clear();
      window.location.href = 'https://lbc.ggi-sa.com/TestKiosk';
    }
    else {
      sessionStorage.clear();
      this.router.navigate(['/BeforeLogin/NewReg']);
    }

  }
  @HostListener('window:resize', ['$event'])
  gotoProposalList() {
    this.clearSessionStorage();

    if (window.innerWidth <= 768) {
      this.HasSide = false;
    }
    this.router.navigate(['/NewDashboard/Proposals']);

  }
  @HostListener('window:resize', ['$event'])
  goToDashboard() {
    this.clearSessionStorage();

    if (window.innerWidth <= 768) {
      this.HasSide = false;
    }
    this.router.navigate(['/NewDashboard/Policy']);

  }
  @HostListener('window:resize', ['$event'])
  gotoNewPolicy() {
    this.clearSessionStorage();

    if (window.innerWidth <= 768) {
      this.HasSide = false;
    }
    this.router.navigate(['/NewDashboard/Welcome']);
  }
  @HostListener('window:resize', ['$event'])
  GoToProfile() {

    if (window.innerWidth <= 768) {
      this.HasSide = false;
    }

  }
  @HostListener('window:resize', ['$event'])
  GoToPolicyWordings() {

    if (window.innerWidth <= 768) {
      this.HasSide = false;
    }
  }

  //@HostListener('window:resize', ['$event'])  
  gotoReNewPolicy() {
    this.clearSessionStorage();

    if (window.innerWidth <= 768) {
      this.HasSide = false;
    }
    this.router.navigate(['/NewDashboard/RenewalPolicies']);
  }


  Dashboard() {
    this.clearSessionStorage();
    this.router.navigate(['./Master/PolicyDashboard']);
  }

  clearSessionStorage() {
    sessionStorage.removeItem("motorbindObj");
    sessionStorage.removeItem("motorObj");
    sessionStorage.removeItem("paymentObj");
    sessionStorage.removeItem("NavFrom");
    sessionStorage.removeItem("newPolicyObj");
    sessionStorage.removeItem("fortObj");
    sessionStorage.removeItem("PaymentReq");
    sessionStorage.removeItem("CurrentRoute");
    sessionStorage.removeItem("mp");
    sessionStorage.removeItem("rp");
    sessionStorage.removeItem("renewObj");
    sessionStorage.removeItem("TplObj");
    sessionStorage.removeItem("backUrl");
    sessionStorage.removeItem("frontUrl");
    sessionStorage.removeItem("LeftUrl");
    sessionStorage.removeItem("RightUrl");
    sessionStorage.removeItem("ChasisUrl");
    sessionStorage.removeItem("TplBindObj");

    sessionStorage.removeItem("frontImg");
    sessionStorage.removeItem("backImg");
    sessionStorage.removeItem("leftImg");
    sessionStorage.removeItem("rightImg");
    sessionStorage.removeItem("ChasisImg");
    sessionStorage.removeItem("InsuredNameAr");


  }

  setLang() {

    $(".row").toggleClass("New")
    let ln = "en";
    if (this.lng == "Arabic") {
      ln = "ar";
      this.lng = "English";
      $("body").addClass("abc");


    }
    else {
      ln = "en";
      this.lng = "Arabic";
      $("body").removeClass("abc");
    }


    //alert(ln);
    this.lngService.setLanguage(ln);
    this.lngService.setLng(ln);
  }



  GoToSubmitClaim() {
    // this.router.navigate(['/NewDashboard/ClaimsIntimation']);
      // window.open("https://njs.ggi-sa.com/online-portal/claims/motor/Intimation","_blank");
      this.showLoading = true; 
      const url = 'https://njs.ggi-sa.com/online-portal/';
  
      // Use a timeout to simulate a loading period before redirection
      setTimeout(() => {
          window.location.href = url;
          this.showLoading = false; 
      }, 1000); // Adjust the delay as needed
  
  }

  GoToClaims() {
    this.ToggleClaims = !this.ToggleClaims;
  }
  // GoToClaimStatus() {
  //   this.router.navigate(['/NewDashboard/ClaimStatus']);
  // }

  GoToClaimStatus() {
    // window.open("https://njs.ggi-sa.com/online-portal/claims/motor/intimation/claim-status","_blank");

    this.showLoading = true; 
    const url = 'https://njs.ggi-sa.com/online-portal/claims/motor/intimation/claim-status';

    // Use a timeout to simulate a loading period before redirection
    setTimeout(() => {
        window.location.href = url;
        this.showLoading = false; 
    }, 1000); // Adjust the delay as needed
  }
  
  GoToComplaints() { 
    this.showLoading = true; 
    const url = 'https://njs.ggi-sa.com/online-portal/ComplaintsPortal/Complaints/Register';

    // Use a timeout to simulate a loading period before redirection
    setTimeout(() => {
        window.location.href = url;
        this.showLoading = false; 
    }, 1000); // Adjust the delay as needed
  }


  


   

}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/NewDashboard/NewDashboard.ts